<div aria-live="polite" aria-atomic="true" style="position: fixed; min-height: 200px; left: 0; bottom: 0;">
  <!-- Расположите это -->
  <div style="position: absolute; bottom: 0; left: 0;">

    <app-toast *ngFor="let toast of notifications" [title]="toast.title" [text]="toast.text" [link]="toast.link"></app-toast>

  </div>
</div>